export default "__VITE_ASSET__B0Esnhy7__"